import { Component, OnInit } from '@angular/core';

import { FireForesightService } from 'src/api/services';
import { StatusType, SiteParameter } from 'src/api/models';
import { ApplicationConfigService } from 'src/service/application-config.service';
import { ActivatedRoute } from '@angular/router';
import { AzureAuthService } from 'src/service/azure-auth.service';
import { FireService } from 'src/service/fire.service';

@Component({
  selector: 'app-panorama',
  templateUrl: './panorama.component.html',
  styleUrls: ['./panorama.component.css']
})
export class PanoramaComponent implements OnInit {
  public list : StatusType[];
  public siteId: number;
  public expandImage: boolean = false;
  public showZoneEditor: boolean = true;
  public selectedImage: SiteParameter;

  constructor(
    public app: ApplicationConfigService, 
    public security: AzureAuthService,
    private svc: FireForesightService, 
    public fire: FireService,
    private route: ActivatedRoute) { }

  ngOnInit(): void {    
    this.svc.FireForesightGetStatusTypes().subscribe(r=>{
      console.log("ngOnInit", r);
      this.list = r;
    });

    this.route.params.subscribe(params => {
      this.siteId = params["siteId"];
      if (this.siteId){
        this.fire.getCamera(this.siteId, false, null);
      }
    });
  }

  
}